import { useMemo } from 'react';
import { isEmpty } from 'lodash';
import { useDimension } from 'hooks';
import { isProgrammaticAccount } from 'modules/account-management/accountType';
import {
    basePlatformValidations,
    campaignPlatformValidations,
} from 'modules/campaigns/config/validations/campaign/platformValidations';
import { usePermissions } from 'modules/taboola-common-frontend-modules/authentication/hooks';
import { useFormDataContext } from 'modules/taboola-common-frontend-modules/formData';
import { isVideoCampaign } from 'services/campaignDimension';
import { HIGH_IMPACT_PACKAGE_PERMISSION } from '../../../config/highImpactPackageOptions';

export const usePlatformTargetingValidations = () => {
    const { data: formData, formAccount } = useFormDataContext();
    const hasHighImpactPackagePermission = usePermissions(HIGH_IMPACT_PACKAGE_PERMISSION);
    const [dimension] = useDimension();

    const validations = useMemo(() => {
        if (isVideoCampaign(dimension)) {
            return basePlatformValidations;
        }
        const campaignTargeting = formData?.campaignTargeting;
        const hasMyAudienceTargeting = !isEmpty(campaignTargeting?.myAudienceTargeting?.include);
        const isProgrammatic = isProgrammaticAccount(formAccount);

        if (hasMyAudienceTargeting || isProgrammatic) {
            return basePlatformValidations;
        }

        return campaignPlatformValidations(hasHighImpactPackagePermission);
    }, [dimension, formData, formAccount, hasHighImpactPackagePermission]);

    return validations;
};
